import { Reducer } from 'redux'
import { ActionTypes, TRolesState } from './types'

export const initialState: TRolesState = {
  loading: false,
  data: null,
}

const reducer: Reducer<TRolesState> = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.GET_ROLES_R:
      return { ...state, loading: true, errors: undefined }
    case ActionTypes.GET_ROLES_S:
      return { ...state, loading: false, errors: undefined, data: action.payload }
    case ActionTypes.GET_ROLES_E:
      return { ...state, loading: false, errors: action.payload }
    
    default:
      return state
  }
}

export { reducer as RolesReducer }